import { render, staticRenderFns } from "./VuesticFeed.vue?vue&type=template&id=71fa3812&"
import script from "./VuesticFeed.vue?vue&type=script&lang=js&"
export * from "./VuesticFeed.vue?vue&type=script&lang=js&"
import style0 from "./VuesticFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticFeed.vue"
export default component.exports